import { all, call, select, put, takeLatest, fork } from "redux-saga/effects"
import { selectors as locationSelectors } from "./location"
import { actionTypes, selectors } from "./outlet"
import { persist } from "../../apis/persist"
import { dealerInfo } from "../../apis/dealer-search"
import { fetchStockData, cacheKeyGen } from "../../apis/outlet"
import { gtmOutletStoreActionTypes } from "../gtm-events"
import { gtmEvent } from "./gtm"

const {
  INIT_OUTLET_STORE,
  LOAD_OUTLET_STORE,
  STEP_CHANGE,
  DEALER_CHANGE_REQUEST,
  DEALER_CHANGE_SUCCESS,
  DEALER_CHANGE_NO_RESULTS,
  DEALER_CONFIRM,
  DEALER_FETCH_START,
  DEALER_FETCH_CANNOT_RESOLVE,
  DEALER_FETCH_SUCCESS,
  DEALER_FETCH_ERROR,
  NAMEPLATE_CHANGE,
  OUTLET_STOCKS_FETCH_START,
  OUTLET_STOCKS_FETCH_SUCCESS,
  OUTLET_STOCKS_FETCH_ERROR
} = actionTypes

export function* fetchStock() {
  let dealerCode,
    id
  yield put({ type: OUTLET_STOCKS_FETCH_START })
  const { dealer, nameplate, outletStockEndpoint } = yield select(selectors.getOutlet)
  if (dealer) {
    ({ dealerCode, id } = dealer)
  }
  const { response, error } = yield call(fetchStockData, {
    dealerCode,
    locationId: id,
    nameplate,
    outletStockEndpoint
  })
  if (error) {
    yield put({ type: OUTLET_STOCKS_FETCH_ERROR, payload: { error } })
  }
  if (response) {
    const availability = response.map(({ nameplate, inStock }) => ({
      nameplate,
      inStock
    }))
    const { stock = [] } = response.find(stock => stock.nameplate === nameplate) || {}
    yield put({
      type: OUTLET_STOCKS_FETCH_SUCCESS,
      payload: {
        availability,
        results: Array.isArray(stock) ? stock : []
      }
    })
  }
}

export function* fetchDealerInfo({ payload: { dealer, postcode } }) {
  if (dealer && postcode) {
    throw new Error("Can only update local dealer from postcode or dealercode")
  }
  if (dealer && dealer.fetched) return
  yield put({ type: DEALER_FETCH_START })
  const search = dealer ? { dealerCode: dealer.dealerCode } : { postcode }
  const { response, error } = yield call(dealerInfo, {
    dealerTypes: ["sales"],
    ...search
  })
  if (response) {
    let singleDealerInfo
    if (response.length !== 1) {
      if (dealer && dealer.id) {
        singleDealerInfo = response.find(({ id }) => id === dealer.id)
      }
    } else {
      singleDealerInfo = response[0]
    }
    if (singleDealerInfo) {
      const dealer = { ...singleDealerInfo, fetched: true }
      const { dealerCode, id } = dealer
      persist({ localDealer: { dealerCode, id } })
      yield put({ type: DEALER_FETCH_SUCCESS, payload: { dealer } })
    } else {
      yield put({ type: DEALER_FETCH_CANNOT_RESOLVE })
    }
  } else {
    yield put({ type: DEALER_FETCH_ERROR, payload: { error } })
  }
}

export function* dealerChangeRequest({ payload }) {
  yield call(fetchDealerInfo, { payload })
  yield call(refreshStock)
}

export function* refreshStock(autoConfirm = false) {
  yield call(fetchStock)
  const { results, dealer, nameplate } = yield select(selectors.getOutlet)
  if ((results && results.length > 0) || !nameplate) {
    yield put({
      type: DEALER_CHANGE_SUCCESS,
      payload: { dealer, dealerConfirm: autoConfirm }
    })
  } else {
    const noResultMessage =
      dealer && dealer.fetched ? { [cacheKeyGen(dealer, nameplate)]: true } : {}
    yield put({
      type: DEALER_CHANGE_NO_RESULTS,
      payload: { noResultMessage, dealerConfirm: autoConfirm }
    })
  }
}

export function* initOutletStore() {
  let { dealer = {} } = yield select(selectors.getOutlet)
  const { postcode } = yield select(locationSelectors.getLocation)
  const { dealerCode } = dealer
  if ((!dealerCode && postcode) || (dealerCode && !dealer.fetched)) {
    yield call(fetchDealerInfo, {
      payload: dealerCode ? { dealer } : { postcode }
    });
    ({ dealer } = yield select(selectors.getOutlet))
  }
  yield call(refreshStock, true)
  yield put({
    type: STEP_CHANGE,
    payload: { step: "SHOW_RESULTS", copyMode: "WELCOME" }
  })
  yield put({ type: LOAD_OUTLET_STORE })
}

export function* nameplateChange() {
  yield call(refreshStock, true)
  yield call(showResults)
}

function* dealerConfirm() {
  const { dealer: { name } } = yield select(selectors.getOutlet)
  yield put(gtmEvent({
    gtmID: gtmOutletStoreActionTypes.SELECT_DEALER_NAME,
    gtmPayload: { dealerName: name }
  }))
  yield call(showResults)
}

export function* showResults() {
  yield put({
    type: STEP_CHANGE,
    payload: { step: "SHOW_RESULTS" }
  })
}

export default function* () {
  yield all([
    fork(function* () {
      yield takeLatest(INIT_OUTLET_STORE, initOutletStore)
    }),
    fork(function* () {
      yield takeLatest(DEALER_CHANGE_REQUEST, dealerChangeRequest)
    }),
    fork(function* () {
      yield takeLatest(NAMEPLATE_CHANGE, nameplateChange)
    }),
    fork(function* () {
      yield takeLatest(DEALER_CONFIRM, dealerConfirm)
    })
  ])
}



// WEBPACK FOOTER //
// ./src/store/actions/outlet-async.js